export default __webpack_public_path__ + "static/media/simpeg-2.032d87f0.png";